import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from "../../services/axiosInstance";
import {
    fetchRackListMove
} from "../pages/dashboard/dashboardSlice";

export default function RackDetailModal({ rack, data, onClose }) {

    const [showMove, setShowMove] = useState(false);
    const [rackList, setRackList] = useState([]);
    const dispatch = useDispatch();

    const rackListMove = useSelector(
        state => state.dashboard.rackListMove
    );

    const [moveData, setMoveData] = useState({
        detail_id: null,
        rack_code: '',
        level_code: ''
    });

    const saveMove = async () => {

       try {

        const response = await axios.post(
            '/dashracking/move-location',
            moveData
        );

           setTimeout(() => {
               window.location.reload();
           }, 500);

        //console.log('SUCCESS', response.data);

        alert('Berhasil dipindah');

        setShowMove(false);

    } catch (err) {

        //console.log('ERROR FULL', err);

        //console.log('ERROR RESPONSE', err.response);

        //console.log('ERROR DATA', err.response?.data);

        //console.log('ERROR MESSAGE', err.message);

        alert(
            err.response?.data?.message ||
            'Gagal memindahkan lokasi'
        );

    }
    };

    useEffect(() => {
        if (showMove) {
            dispatch(fetchRackListMove());
        }
    }, [showMove, dispatch]);

    const isExpired = (date) => {
        return new Date(date) < new Date();
    };

    if (!rack) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white w-[600px] rounded-2xl shadow-lg p-6">

                {/* HEADER */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="font-bold text-lg">
                        Rack Detail  - {rack.level_code}
                    </h2>
                    <button onClick={onClose} className="text-red-500">X</button>
                </div>

                {/* CONTENT */}
                {!data ? (
                    <div>Loading...</div>
                ) : (
                    <div className="space-y-3 max-h-[400px] overflow-auto">
                        {data.map((item, i) => (
                            <div
                                key={i}
                                className={`border p-3 rounded ${isExpired(item.due_date) ? "bg-red-100" : ""}`}
                            >
                                <div className="flex justify-between">
                                    <div className="font-semibold">{item.sku} - {item.name_product}</div>
                                    <span className="text-xs bg-blue-100 px-2 rounded">
                                        {item.kode_palet}
                                    </span>
                                </div>

                                <div className="text-xs">Kode Palet: {item.kode_palet}</div>
                                <div className="text-xs">Lot Number: {item.batch_no}</div>
                                <div className="text-xs">Qty: {item.qty}</div>
                                <div className="text-xs">Exp: {item.due_date}</div>
                                <div className="text-xs">
                                    <button
                                        className="mt-2 bg-blue-500 text-white px-3 py-1 rounded"
                                        onClick={() => {
                                            setMoveData({
                                                detail_id: item.id,
                                                rack_code: '',
                                                level_code: item.level_code || ''
                                            });

                                            setShowMove(true);
                                        }}
                                    >
                                        Move
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {
                    showMove && (
                        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
                            <div className="bg-white p-5 rounded-xl w-[400px]">

                                <h3 className="font-bold mb-4">
                                    Move Location
                                </h3>

                                <div className="mb-3">
                                    <label>Rack Tujuan</label>

                                    <select
                                        className="border w-full p-2 rounded"
                                        value={moveData.rack_code}
                                        onChange={(e) =>
                                            setMoveData({
                                                ...moveData,
                                                rack_code: e.target.value
                                            })
                                        }
                                    >
                                        <option value="">
                                            Pilih Rack
                                        </option>

                                        {rackListMove.map((rack) => (
                                            <option
                                                key={rack.id}
                                                value={rack.code}
                                            >
                                                [{rack.warehouse_name}] {rack.code} - {rack.racks_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label>Level Tujuan</label>

                                    <input
                                        type="text"
                                        className="border w-full p-2 rounded"
                                        value={moveData.level_code}
                                        onChange={(e) =>
                                            setMoveData({
                                                ...moveData,
                                                level_code: e.target.value
                                            })
                                        }
                                    />
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        className="px-3 py-2 border rounded"
                                        onClick={() => setShowMove(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="px-3 py-2 bg-green-600 text-white rounded"
                                        onClick={saveMove}
                                    >
                                        Save
                                    </button>
                                </div>

                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}